import React, { useState } from "react";
import { Reveal, HeartIcon } from "../ui";

export default function Download() {
  const [showComingSoon, setShowComingSoon] = useState(false);

  return (
    <section
      className="bg-black py-16 lg:py-[100px] px-[5%] text-center relative overflow-hidden"
      id="download"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full"
          style={{
            background:
              "radial-gradient(circle, rgba(208,32,168,0.1) 0%, transparent 65%)",
          }}
        />
      </div>
      <div className="relative z-10">
        <Reveal direction="scale">
          <div className="w-[72px] h-[72px] rounded-[20px] bg-rose flex items-center justify-center mx-auto mb-7">
            <HeartIcon className="w-9 h-9 text-white" />
          </div>
        </Reveal>
        <Reveal>
          <h2 className="text-[clamp(32px,5vw,56px)] font-bold tracking-[-1.5px] text-white mb-3.5">
            Your connection is waiting.
          </h2>
        </Reveal>
        <Reveal delay={100}>
          <p className="text-[17px] text-white/45 max-w-[480px] mx-auto leading-relaxed font-light mb-8 lg:mb-10">
            Download Max &amp; Sherry ConnectPlus and start connecting with
            people who fit your vibe, your values, and your vision.
          </p>
        </Reveal>
        <Reveal delay={150}>
          <div className="flex gap-3.5 justify-center flex-wrap">
            <button
              type="button"
              onClick={() => setShowComingSoon(true)}
              className="flex items-center gap-3 bg-white/8 border border-white/12 text-white px-6 py-3 rounded-[14px] hover:bg-white/14 hover:-translate-y-0.5 transition-all duration-200 min-w-[160px]"
            >
              <svg
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-7 h-7 flex-shrink-0"
              >
                <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.7 9.05 7.07c1.3.02 2.21.69 2.98.73.97-.14 1.85-.82 3.08-.88 1.42.04 2.56.66 3.25 1.66-3.18 1.71-2.7 5.79.63 6.71-.28 1.03-.82 2.03-1.94 2.99zm-4.97-14.7c-.16 1.7.97 3.39 2.67 3.52.22-1.75-.99-3.39-2.67-3.52z" />
              </svg>
              <div className="text-left">
                <div className="text-[10px] text-white/40 uppercase tracking-wide">
                  Download on the
                </div>
                <div className="text-base font-semibold">App Store</div>
              </div>
            </button>

            <a
              href="https://drive.google.com/drive/folders/11sxB-o7OWIcYXzfplG4qOys3N41cG-Na"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 bg-white/8 border border-white/12 text-white px-6 py-3 rounded-[14px] hover:bg-white/14 hover:-translate-y-0.5 transition-all duration-200 min-w-[160px]"
            >
              <svg
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-7 h-7 flex-shrink-0"
              >
                <path d="M3.18 23.76c.3.16.64.2.99.1l12.83-7.37-2.78-2.78L3.18 23.76zm-1.5-20.47C1.42 3.6 1.25 4 1.25 4.5v15c0 .5.17.9.43 1.2l.07.06 8.4-8.4v-.2L1.68 3.29zm14.38 8.34l-2.88-2.88-2.86 2.86 2.88 2.88 2.86-2.86zm3.34-5.01L18.1 5.03l-8.85 5.06 3.07 3.07 6.08-6.54z" />
              </svg>

              <div className="text-left">
                <div className="text-[10px] text-white/40 uppercase tracking-wide">
                  Get it on
                </div>
                <div className="text-base font-semibold">Google Play</div>
              </div>
            </a>
          </div>
        </Reveal>
      </div>

      {showComingSoon && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm px-5"
          onClick={() => setShowComingSoon(false)}
        >
          <div
            className="w-full max-w-sm rounded-[24px] bg-[#151515] border border-white/10 p-7 text-center shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="w-14 h-14 rounded-full bg-rose/15 flex items-center justify-center mx-auto mb-5">
              <HeartIcon className="w-7 h-7 text-rose" />
            </div>

            <h3 className="text-2xl font-bold text-white mb-2">Coming Soon</h3>

            <p className="text-white/50 text-sm leading-relaxed mb-6">
              The Max &amp; Sherry app is coming soon to the App Store. Stay
              tuned!
            </p>

            <button
              type="button"
              onClick={() => setShowComingSoon(false)}
              className="w-full bg-rose text-white py-3 rounded-[12px] font-semibold hover:opacity-90 transition-opacity"
            >
              Got it
            </button>
          </div>
        </div>
      )}
    </section>
  );
}
